import { render, staticRenderFns } from "./ChoiceImage.vue?vue&type=template&id=1f60ca3e"
import script from "./ChoiceImage.vue?vue&type=script&lang=ts"
export * from "./ChoiceImage.vue?vue&type=script&lang=ts"
import style0 from "./ChoiceImage.vue?vue&type=style&index=0&id=1f60ca3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@3.6.0_webpack@4.47.0__ejs@3.1.10_be517b630ad34e2df4a68e8854480672/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports